(function mainThemeScript($, Drupal) {
  Drupal.behaviors.plStarter = {
    attach(context) {
      $('html', context).addClass('js');
      $('.section__contact_form__row svg').css('margin-right', '1em');

      // add smooth scroll
      $('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function (event) {
          // On-page links
          if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
            location.hostname == this.hostname
          ) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
              // Only prevent default if animation is actually gonna happen
              console.log('scrolling to', target)
              var offset = target.offset().top;
              if (target[0].id === 'blog' || target[0].id === 'contact') offset = offset - 200;
              event.preventDefault();
              $('html, body').animate({
                scrollTop: offset
              }, 1000, function () {
                // Callback after animation
                // Must change focus!
                var $target = $(target)[0];
                $target.scrollIntoView();
                $target.focus();
                // if ($target.is(":focus")) { // Checking if the target was focused
                //   return false;
                // } else {
                //   $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                //   $target.focus(); // Set focus again
                // };
              });
            }
          }
        });

      scrollToTarget()

      function scrollToTarget() {
        if (
          location.hash
        ) {
          // Figure out element to scroll to
          var target = location.hash;
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']') ? target: $('[data-hash="' + this.hash.slice(1) + '"]');
          var targetAlt = $('[data-hash="' + location.hash.slice(1) + '"]')
          // target = $(target)
          // Does a scroll target exist?
          if (targetAlt.length > 0) {
            automatedScroll(targetAlt[0])

          } else if (target.length ) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            console.log('scrolling to', target, $(target))
            var offset = target.offset().top - 200
            $('html, body').animate({
              scrollTop: 0
            }, 1000, function () {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(":focus")) { // Checking if the target was focused
                return false;
              } else {
                $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              };
            });
          }
          if (targetAlt) {
            console.log('scrolling to', targetAlt[0])
          }

        }
      }
      //
      hideMessages();

      function automatedScroll(target) {
        // console.log('scrolling to', target, target.scrollIntoView())
        var offset = $(target).offset().top - 200
        $('html, body').animate({
          scrollTop: 0
        }, 100, function () {
          // Callback after animation
          // Must change focus!
          var $target = $(target)[0];
          $target.scrollIntoView();
          $target.focus();
          // if ($target.is(":focus")) { // Checking if the target was focused
          //   return false;
          // } else {
          //   $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
          //   $target.focus(); // Set focus again
          // };
        });

      }

      function hideMessages() {
        const message = $('.message');
        if (message) setTimeout(() => {
          $(message).hide();
        }, 4000);
      }

      function trackMenuClick() {
        const hamburger = $('.site__header__mobile-menu--trigger i.icon--menu');
        const close = $('.site__header__mobile-menu--trigger i.icon--close');
        $(hamburger).on('click', openMenu);
        close.on('click', closeMenu);
      }

      function trackMenuItemClicks() {
        let menuItems = $('.site__header .hamburgerOpen .c-primary-nav__item');
        console.log(menuItems)
        menuItems.each(function (e) {
          trackMenuItemClick($(this));
        });
      }

      function trackMenuItemClick(e) {
        $(e).on('click', closeMenu);
      }

      function openMenu() {
        const menu = $('.site__header .c-primary-nav__list')
        menu.addClass('hamburgerOpen');
        menu.css('display', 'flex');
        const hamburger = $('.site__header__mobile-menu--trigger i.icon--menu')
        const close = $('.site__header__mobile-menu--trigger i.icon--close');
        hamburger.toggle();
        close.toggle();
        trackMenuItemClicks();

      }

      function closeMenu() {
        const menu = $('.site__header .c-primary-nav__list')
        menu.removeClass('hamburgerOpen');
        menu.css('display', 'none');
        const hamburger = $('.site__header__mobile-menu--trigger i.icon--menu')
        const close = $('.site__header__mobile-menu--trigger i.icon--close');
        hamburger.toggle();
        close.toggle();

      }
      trackMenuClick();
      trackMenuItemClicks();
      removeDosenfleisch();

      function generateRandomSessionId() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : r & 0x3 | 0x8;
          return v.toString(16);
        });
      }
      // TODO: re-enable this
      // TODO: make tracker POST url configurable

      function trackPageView() {
        if(getCookie('gdpr-agreed') == 1)
          console.log('agreed to consent, tracking is ok')

          enableGA();
          $.ajax("https://tracker.nido.lb.ranch-1.myzel.io/pageview", {
            data: JSON.stringify({
              "id": generateRandomSessionId(),
              "page": window.location.pathname,
            }),
            type: "POST",
            contentType: 'application/json'

          }).done(function (res) {
            console.log(res)
          });
      }


        function enableGA() {
                var s = document.createElement('script');
                s.type = 'text/javascript';
        var code = `(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
                  (i[r].q=i[r].q||[]).push(arguments)

                },i[r].l=1*new Date();a=s.createElement(o),
            m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
            })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

          ga('create', 'UA-143723984-1', 'auto');
          ga('send', 'pageview');`;
                  try {
                                  s.appendChild(document.createTextNode(code));
                                                  document.body.appendChild(s);


                  } catch (e) {
                                  s.text = code;
                                                  document.body.appendChild(s);


                  }

      }
      function setCookie(name, value, days) {
        var expires = "";
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
      }

      function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
      }

      function eraseCookie(name) {
        document.cookie = name + '=; Max-Age=-99999999;';
      }

      function gdprAccepted() {
        eraseCookie('gdpr-agreed');
        setCookie('gdpr-agreed', 1, 100);
        $('.gdpr-cookie').fadeOut()
        trackPageView()
      }

      function gdprDeclined() {
        eraseCookie('gdpr-agreed');
        setCookie('gdpr-agreed', 0 , 100);
        $('.gdpr-cookie').fadeOut()
      }

      function gdprCookieInit() {
        if(getCookie('gdpr-agreed') == 1) {
          trackPageView()
          return;
        }
        $('.gdpr-cookie').fadeIn()
        // $(".gdpr-cookie").show("slide", {direction: "up"}, "slow");
        var acceptBtn = $('.gdpr-cookie button[rel="accept"]')[0];
        var declineBtn = $('.gdpr-cookie button[rel="decline"]')[0];
        acceptBtn.addEventListener('click', gdprAccepted)
        declineBtn.addEventListener('click', gdprDeclined)
      }

      function removeDosenfleisch() {
        $('#dosenfleisch').remove();
        $('#dosenfleischTimer').css('visibility', 'hidden');
        $('#dosenfleischTimer').css('width', '0');
        $('#dosenfleischTimer').css('padding', '0');
        $('#dosenfleischTimer').css('margin', '0');
        $('#dosenfleischMessage').hide();
        setTimeout(function() {
          $("#dosenfleischTimer")[0].value = 'keinDosenfleisch'

        }, 5000);
      }


      $(function () {
        gdprCookieInit();
        var sectionStartQuery = '#start'
        var sectionInvestorQuery = '#for-investors'
        var controller = new ScrollMagic.Controller();
        var viewportH = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        // var scene = new ScrollMagic.Scene({
        //   duration: 1000 ,    // the scene should last for a scroll distance of px
        //   offset: 0    // start this scene after scrolling for px
        // })
        // .addTo(controller); // assign the scene to the controller
        // scene.triggerElement(sectionStartQuery)
        // var triggerElement = scene.triggerElement()

        // scene.on("progress", function (event) {
        //   triggerElement.style.setProperty('--opac', 1 - event.progress)
        // });


        $('.section__bg').each(function () {
          console.log(this)
          var scene = new ScrollMagic.Scene({
              triggerElement: this,
              // triggerHook: 0
              duration: viewportH / 1.4, // the scene should last for a scroll distance of px
            })
            .addTo(controller); // assign the

          var triggerElement = scene.triggerElement()
          scene.on("progress", function (event) {
            let opacity = event.progress * 2;
            if (event.progress <= 1 && event.progress >= 0.5) opacity = ((1 - event.progress) * 2);
            triggerElement.style.setProperty('--opac', opacity)
          });

        })


      });

    },
  };
}(jQuery, Drupal));
